/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F4_QInputs */

const en_mk_sec_pg_f4_q = /** @type {(inputs: Mk_Sec_Pg_F4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens to our data if we stop subscribing?`)
};

const id_mk_sec_pg_f4_q = /** @type {(inputs: Mk_Sec_Pg_F4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang terjadi pada data kami kalau kami berhenti berlangganan?`)
};

/**
* | output |
* | --- |
* | "What happens to our data if we stop subscribing?" |
*
* @param {Mk_Sec_Pg_F4_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f4_q = /** @type {((inputs?: Mk_Sec_Pg_F4_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F4_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f4_q(inputs)
	return en_mk_sec_pg_f4_q(inputs)
});